import { CmsApiGradCtaHeroBlockData } from 'modules/cms/api/types/CmsApiGradCtaHero';
import { CmsAmpHeroBlock } from 'modules/cms/blocks/Amp/Hero';
import { CmsAmpBlockMappingComponentProps } from 'modules/cms/blocks/CmsBlockMapping';

export function CmsAmpGradCtaHeroBlock({
  content,
  data,
  blockId,
}: CmsAmpBlockMappingComponentProps<CmsApiGradCtaHeroBlockData>) {
  return (
    <CmsAmpHeroBlock
      content={content}
      data={{
        ...data,
        isGrad: true,
        buttonText: undefined,
        buttonUrl: undefined,
      }}
      blockId={blockId}
    />
  );
}
